(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-slide"]) return;
  try {
    
  if (!customElements.get('shipping-bar')) {
    customElements.define(
      'shipping-bar',
      class ShippingBar extends HTMLElement {
        constructor() {
          super();
          this.threshold = 0;
          this.cartTotals = 0;
        }

        setString() {
          // Log shipping and discount amounts from labels
          const shippingLabel = this.querySelector('.cart-slide__label-freeshiping');
          const discountLabel = this.querySelector('.cart-slide__label-discount');

          // Validate and parse settings data
          const dataRate = parseFloat(this.dataset.amount);

          if (isNaN(dataRate) || dataRate <= 0) {
            return;
          }

          // Use store's base currency without conversion
          const amountCalc = dataRate;
          const cartTotals = parseFloat(this.dataset.cartTotals) / 100;

          if (isNaN(cartTotals)) {
            return;
          }

          const amount = (amountCalc - cartTotals) * 100;

          // Find text container within the same cart context (cart drawer or cart page)
          const cartContext = this.closest('cart-slide') || this.closest('.main-cart');
          const textContainer = cartContext
            ? cartContext.querySelector('[data-shipping-bar-text]')
            : document.querySelector('[data-shipping-bar-text]');

          const wrapper = this.closest('.shipping-bar-wrapper');
          if (textContainer) {
            if (amount > 0) {
              this.classList.remove('shipping-unlocked');
              wrapper?.classList.remove('shipping-unlocked');
              // Store original text if not already stored
              if (!this.dataset.originalText) {
                this.dataset.originalText = textContainer.innerHTML;
              }
              const base = this.dataset.originalText;
              const moneyFormat = this.dataset.moneyFormat || window.money_format;
              textContainer.innerHTML = base.replace(/\|\|amount\|\|/g, Shopify.formatMoney(amount, moneyFormat));
              textContainer.style.fontWeight = '400';
            } else {
              this.classList.add('shipping-unlocked');
              wrapper?.classList.add('shipping-unlocked');
              textContainer.innerHTML = this.dataset.shippingMessage || '✓ FREE Shipping Unlocked!';
              textContainer.style.fontWeight = '700';
            }
          }

          this.threshold = amountCalc;
          this.cartTotals = cartTotals;
        }

        setBar() {
          const element = this.querySelector('[data-progress-span]');
          if (!element) {
            return;
          }

          if (!this.threshold || this.threshold <= 0) {
            return;
          }

          // Find the maximum threshold from all labels (shipping and discount)
          // Use store's base currency without conversion
          const shippingLabel = this.querySelector('.cart-slide__label-freeshiping');
          const discountLabel = this.querySelector('.cart-slide__label-discount');

          let maxThreshold = this.threshold; // Start with shipping threshold

          if (shippingLabel) {
            const shippingPrice = parseFloat(shippingLabel.dataset.price);
            if (!isNaN(shippingPrice) && shippingPrice > maxThreshold) {
              maxThreshold = shippingPrice;
            }
          }

          if (discountLabel) {
            const discountPrice = parseFloat(discountLabel.dataset.price);
            if (!isNaN(discountPrice) && discountPrice > maxThreshold) {
              maxThreshold = discountPrice;
            }
          }

          const rawValue = (this.cartTotals / maxThreshold) * 100;
          const value = Math.min(100, Math.max(0, rawValue));

          element.setAttribute('data-value', value.toFixed(2));
          element.style.setProperty('--bar-width', `${value.toFixed(2)}%`);
          element.innerText = value.toFixed(2);

          // Position icons
          this.positionIcons();
        }

        positionIcons() {
          const marks = this.querySelectorAll('.cart-slide__label');
          if (marks.length === 0) return;

          // Use store's base currency without conversion
          // Find the maximum threshold value from all marks
          let maxThreshold = this.threshold;

          marks.forEach((mark, index) => {
            const price = parseFloat(mark.dataset.price);

            if (!isNaN(price) && price > 0) {
              if (price > maxThreshold) {
                maxThreshold = price;
              }
            }
          });

          if (maxThreshold <= 0) {
            return;
          }

          // Position each mark based on percentage
          marks.forEach((mark, index) => {
            const price = parseFloat(mark.dataset.price);
            if (isNaN(price) || price <= 0) {
              return;
            }

            const rawPercent = (price / maxThreshold) * 100;
            let percentPosition = Math.min(100, Math.max(0, rawPercent));

            // If only one label exists and it's positioned at 100%, adjust it slightly left
            // to prevent text overflow on the right side
            if (marks.length === 1 && percentPosition >= 95) {
              percentPosition = 95;
            }

            mark.style.position = 'absolute';
            mark.style.left = `${percentPosition}%`;
            mark.style.top = '0px';
            mark.style.transform = 'translateX(-50%)';
          });
        }

        updateCartTotals(cartTotalPrice) {
          if (cartTotalPrice === undefined || cartTotalPrice === null) {
            return;
          }

          this.dataset.cartTotals = cartTotalPrice;
          this.setString();
          this.setBar();
        }

        connectedCallback() {
          this.setString();
          this.setBar();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparison-section"] && !Shopify.designMode) return;
  try {
    
  const compresion_block = document.getElementById('comparison-table-w');
  const compresion_scrollText = document.getElementById('scroll_text');

  if (compresion_block && compresion_scrollText) {
    window.addEventListener('load', onLoadFunction);
    window.addEventListener('resize', onLoadFunction);
  }

  function onLoadFunction(e) {
    if (!compresion_block || !compresion_scrollText) return;
    let compresion_isHorizontalScroll = compresion_block.scrollWidth > compresion_block.clientWidth;
    compresion_isHorizontalScroll
      ? compresion_scrollText.classList.add('scroll-on')
      : compresion_scrollText.classList.remove('scroll-on');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contactus"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const contactForm = document.querySelector('#ContactForm');
    if (!contactForm) return;

    const nameInput = contactForm.querySelector('input[name="contact[name]"]');
    const emailInput = contactForm.querySelector('input[name="contact[email]"]');
    const submitBtn = contactForm.querySelector('.submit-button');

    if (!nameInput || !emailInput || !submitBtn) return;

    // Initially disable submit
    submitBtn.disabled = true;

    const validateForm = () => {
      const nameValid = nameInput.value.trim().length > 0;
      const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value.trim());
      submitBtn.disabled = !(nameValid && emailValid);
    };

    // Listen for input changes
    nameInput.addEventListener('input', validateForm);
    emailInput.addEventListener('input', validateForm);

    // Optionally, prevent submission if JS disabled somehow
    contactForm.addEventListener('submit', (e) => {
      if (submitBtn.disabled) e.preventDefault();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyBlock extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      if (!this.dataset.refBlock && !this.dataset.behavior) return;
      const stickyHide = () => {
        this.setAttribute('data-revealed', false);
        if (this.dataset.hasHidden === 'true') this.setAttribute('aria-hidden', true);
        if (this.dataset.bodyClass) document.body.classList.remove(this.dataset.bodyClass);
        if (this.height) {
          this.style.removeProperty('height');
          if (this.dataset.bodyClass) document.body.style.removeProperty('--page-header-height');
        }
      };
      const initialize = () => {
        this.behavior = this.dataset.behavior;
        this.spacer = this.dataset.spacer;
        this.endBounds = document.body.offsetHeight + this.offsetHeight;
        if (this.behavior) {
          switch (this.behavior) {
            case 'downwards':
              window.addEventListener('scroll', onDownwardScroll.bind(this));
              break;
            case 'upwards':
              window.addEventListener('scroll', onUpwardScroll.bind(this));
              break;
            case 'stacked':
              window.addEventListener('scroll', onStackedScroll.bind(this));
              break;
            case 'observer':
              window.addEventListener('scroll', onObservedScroll.bind(this));
              break;
            default:
              break;
          }
        }
        this.refBlock = document.querySelector(this.dataset.refBlock);
        if (!this.refBlock) return;
        this.refBoundings = this.refBlock.getBoundingClientRect();
        this.offset = this.dataset.offset ? parseFloat(this.dataset.offset) : 0;
        this.threshold = this.refBlock.offsetTop + this.refBoundings.height + this.offset;
        this.previousScrollAmount = window.screenY;
        this.percent = this.dataset.pagePercentage ? this.dataset.pagePercentage : null;
        if (this.spacer) this.height = this.refBlock.offsetHeight;
      };
      const onObservedScroll = () => {
        let revealedAttr = true;
        const handleObserver = (entries, observer) => {
          observer.unobserve(this);
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              revealedAttr = false;
            } else {
              revealedAttr = true;
            }
            setStickyStatus(revealedAttr);
          });
        };
        new IntersectionObserver(handleObserver, { rootMargin: '0px 0px -60px 0px' }).observe(this);
      };
      const onDownwardScroll = () => {
        let revealedAttr = false;
        if (this.percent) {
          const pageHeight = document.documentElement.offsetHeight;
          const threshold = (pageHeight * parseFloat(this.percent)) / 100;
          this.threshold = threshold;
        }
        if (window.scrollY > this.threshold) revealedAttr = true;
        setStickyStatus(revealedAttr);
      };
      const onUpwardScroll = () => {
        let revealedAttr = false;
        const threshold = this.height ? this.height : this.refBlock.offsetHeight;

        if (window.scrollY > this.previousScrollAmount) {
          revealedAttr = false;
        } else if (window.scrollY < this.previousScrollAmount) {
          revealedAttr = true;
          if (window.scrollY < threshold) revealedAttr = false;
        }
        setStickyStatus(revealedAttr);
        this.previousScrollAmount = window.scrollY;
      };
      const onStackedScroll = () => {
        let revealedAttr = false;
        if (this.refBoundings.y < 0) this.refBoundings.y += window.scrollY;
        if (this.refBoundings.y < window.scrollY) revealedAttr = true;
        setStickyStatus(revealedAttr);
      };
      const setStickyStatus = (revealed) => {
        if (this.dataset.hideOnEnd === 'true')
          if (window.innerHeight + window.scrollY >= this.endBounds) return stickyHide();
        if (revealed) {
          this.setAttribute('data-revealed', true);
          if (this.dataset.hasHidden === 'true') this.removeAttribute('aria-hidden');
          if (this.dataset.bodyClass) document.body.classList.add(this.dataset.bodyClass);
          if (this.height) {
            this.style.height = this.height + 'px';
            if (this.dataset.bodyClass) document.body.style.setProperty('--page-header-height', this.height + 'px');
          }
          return;
        }
        stickyHide();
      };
      const setTempoStatus = (flag, refContainer) => {
        const refElement = document.querySelector(refContainer);
        if (!refElement) return;
        refElement.style.transform = flag ? 'translateY(0%)' : 'translateY(-100%)';
      };
      this.setTempoStatus = setTempoStatus;
      this.setStickyStatus = setStickyStatus;
      this.initLoad = setTimeout(initialize.bind(this), 100);
      document.addEventListener('DOMContentLoaded', function () {
        this.initLoad;
      });
    }
  }
  if (!customElements.get('sticky-block')) {
    customElements.define('sticky-block', StickyBlock);
  }

  document.addEventListener('DOMContentLoaded', () => {
    const updateHeaderHeight = () => {
      const announcementBars = document.querySelectorAll('.announcement-bar');
      const pageHeader = document.querySelector('.page-header');
      let totalHeight = 0;
      announcementBars.forEach((bar) => {
        totalHeight += bar.offsetHeight || 0;
      });

      if (pageHeader) {
        totalHeight += pageHeader.offsetHeight || 0;
      }
      document.body.style.setProperty('--header-total-height', `${totalHeight}px`);
    };

    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight);
    const observer = new MutationObserver(updateHeaderHeight);
    observer.observe(document.body, { childList: true, subtree: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code.toUpperCase() !== 'TAB') return;
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (event.target !== container && event.target !== last && event.target !== first) return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
    ) {
      elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
  };
  const debounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  };
  const setFilterParam = (param, value, remove = false, getParams = false) => {
    const input = document.getElementById('filters-params');
    const url = new URL(input.value, window.location.origin);
    if (getParams) return new URLSearchParams(url.searchParams).toString();
    switch (remove) {
      case true:
        if (param.includes('price')) {
          [...url.searchParams.keys()].forEach((key) => key.includes('filter.v.price') && url.searchParams.delete(key));
        } else {
          if (!value) {
            url.searchParams.delete(param);
          } else {
            const valToDel = value;
            const values = url.searchParams.getAll(param);
            const updatedValues = values.filter((value) => value !== valToDel);
            url.searchParams.delete(param);
            updatedValues.forEach((value) => url.searchParams.append(param, value));
          }
        }
        break;
      case 'all':
        [...url.searchParams.keys()].forEach((key) => key.includes('filter') && url.searchParams.delete(key));
        break;

      default:
        if (param.includes('price')) {
          url.searchParams.set(param, value);
        } else {
          url.searchParams.append(param, value);
        }
        break;
    }

    input.value = url.toString();
  };
  const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if (!loader) return;
    if (state) {
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease',
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease',
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  class FiltersDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.items = this.querySelectorAll('input');
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }
    connectedCallback() {
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query)) {
          this.content.classList.add(...classes);
          return;
        }
        if (screen.width >= query) this.content.classList.add(...classes);
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
        this.initFilters();
        if (this.closeButton) this.closeButton.addEventListener('click', this.closeDropdown);
      };
      const closeDropdown = () => {
        closeDetailsTag();
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        self.button.focus();
        document.body.removeEventListener('click', onBodyClick);
        self.removeEventListener('keyup', onKeyUp);
        this.fields.forEach((field) => {
          field.removeEventListener('input', this.debouncedOnSubmit.bind(this));
        });
        if (this.closeButton) this.closeButton.removeEventListener('click', this.closeDropdown);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          (target === self.button && self.button.getAttribute('aria-expanded') === 'true')
        )
          return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      const closeDetailsTag = () => {
        const tags = this.querySelectorAll('details');
        tags.forEach((tag) => {
          tag.removeAttribute('open');
        });
      };
      applyColorScheme();
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }

    initFilters() {
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 300);
      this.fields = this.querySelectorAll('input');
      this.fields.forEach((field) => {
        field.addEventListener('input', this.debouncedOnSubmit.bind(this));
      });
    }

    onSubmitHandler(event) {
      event.preventDefault();
      const target = event.target;
      switch (target.type) {
        case 'checkbox':
          setFilterParam(target.name, target.value, !target.checked);
          break;
        case 'number':
          setFilterParam(target.name, target.value);
          break;
        default:
          break;
      }
      const facetsFilter = document.querySelector('facets-filter');
      facetsFilter.onSubmitHandler(target.id);
    }
  }
  if (!customElements.get('filters-dropdown')) {
    customElements.define('filters-dropdown', FiltersDropdown);
  }
  class SortDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.items = this.content.querySelectorAll('[data-btn-sort]');
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }
    connectedCallback() {
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const setCurrentValue = (target) => {
        const elem = self.button.querySelector('[data-current-value]');
        elem.textContent = target.dataset.text;
        setFilterParam('sort_by', target.dataset.value);
        const facetsFilter = document.querySelector('facets-filter');
        facetsFilter.onSubmitHandler();
        self.closeDropdown();
      };
      const onSortSelect = (event) => {
        const target = event.target;
        self.items.forEach((item) =>
          item.classList.remove('main-featured-product-grid_facets-sort-action-btn--active')
        );
        target.classList.add('main-featured-product-grid_facets-sort-action-btn--active');
        setCurrentValue(target);
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query)) {
          this.content.classList.add(...classes);
          return;
        }
        if (screen.width >= query) this.content.classList.add(...classes);
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
        self.items.forEach((item) => {
          item.addEventListener('click', self.sortSelect);
        });
        if (this.closeButton) this.closeButton.addEventListener('click', this.closeDropdown);
      };
      const closeDropdown = () => {
        const outerSelf = self.closest('menu-dropdown[data-level="1"]');
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        if (self.dataset.level === '2') trapFocus(outerSelf.content);
        self.button.focus();
        document.body.removeEventListener('click', onBodyClick);
        self.removeEventListener('keyup', onKeyUp);
        this.items.forEach((item) => {
          item.removeEventListener('click', self.sortSelect);
        });
        if (this.closeButton) this.closeButton.removeEventListener('click', this.closeDropdown);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          (target === self.button && self.button.getAttribute('aria-expanded') === 'true')
        )
          return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      applyColorScheme();
      this.sortSelect = onSortSelect.bind(this);
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('sort-dropdown')) {
    customElements.define('sort-dropdown', SortDropdown);
  }

  class FacetRemoveButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;

      this.button.addEventListener('click', (event) => {
        event.preventDefault();

        const { name, value, valueArr } = this.dataset;
        const values = valueArr || value || null;

        setFilterParam(name === 'all' ? null : name, values, name === 'all' ? 'all' : true);

        const facetsFilter = document.querySelector('facets-filter');
        facetsFilter?.onSubmitHandler?.();
      });
    }
  }

  if (!customElements.get('facet-remove-button')) customElements.define('facet-remove-button', FacetRemoveButton);

  class FacetsFilter extends HTMLElement {
    constructor() {
      super();

      this.cachedResults = [];
      window.addEventListener('popstate', this.onHistoryChange.bind(this));
    }

    connectedCallback() {
      this.initParams = setFilterParam(null, null, false, true);
    }

    onHistoryChange(event) {
      if (event.state && this.cachedResults.length === 0) {
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const sectionsInput = document.querySelector('#filters-sections');
        const baserUrl = document.querySelector('#base-url');
        const url = baserUrl.value + '?' + searchParams + sectionsInput.value;
        this.renderFetch(url, false, searchParams);
        return;
      }

      if (this.cachedResults && this.cachedResults.length > 0) {
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const term = { params: searchParams };
        if (this.cachedResults.some((key) => key.params === term.params))
          return this.renderFromCache(this.cachedResults, term, false);
        const sectionsInput = document.querySelector('#filters-sections');
        const baserUrl = document.querySelector('#base-url');
        const url = baserUrl.value + '?' + searchParams + sectionsInput.value;
        this.renderFetch(url, false, searchParams);
      }
    }

    onSubmitHandler(target) {
      toggleLoader(true);
      const input = document.querySelector('#filters-params');
      let inputValue = input.value;
      if (!inputValue.includes('?')) inputValue = input.value + '?';
      const sectionsInput = document.querySelector('#filters-sections');
      const url = inputValue + sectionsInput.value;
      const searchParams = setFilterParam(null, null, false, true);
      const term = { params: searchParams };
      if (this.cachedResults.length > 0 && this.cachedResults.some((key) => key.params === term.params)) {
        this.renderFromCache(this.cachedResults, term, true, target);
        return;
      }
      this.renderFetch(url, true, searchParams, target);
    }

    renderFetch(url, updateURLHash = false, searchParams, target = null) {
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          const secArr = JSON.parse(this.dataset.sections);
          secArr.forEach((section) => {
            const html = new DOMParser().parseFromString(data[section.id], 'text/html').getElementById(section.id);
            section.selectors.forEach((selector) => {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.outerHTML = sourceElement.outerHTML;
              }
            });
          });
          const cacheObj = { params: searchParams, content: data };
          this.cachedResults.push(cacheObj);
        })
        .catch((e) => {
          throw e;
        })
        .finally(() => {
          if (updateURLHash) this.updateURLHash(searchParams);
          const filtersDropdown = document.querySelector('filters-dropdown');
          // Only toggle filter drawer if it's already open (to close it), not when sorting
          if (filtersDropdown && filtersDropdown.button && filtersDropdown.button.getAttribute('aria-expanded') === 'true') {
            filtersDropdown.button.dispatchEvent(new Event('click'));
          }
          if (target) this.handleDropdown(target);
          toggleLoader(false);
        });
    }

    handleDropdown(target) {
      const org = document.getElementById(target);
      const dropdown = org.closest('details');
      dropdown.setAttribute('open', '');
      org.focus();
    }

    renderFromCache(cache, filter, updateURLHash = false, target = null) {
      const cacheDataArr = cache;
      const cachedResults = cacheDataArr.find((results) => results.params === filter.params);
      const secArr = JSON.parse(this.dataset.sections);
      secArr.forEach((section) => {
        const html = new DOMParser()
          .parseFromString(cachedResults.content[section.id], 'text/html')
          .getElementById(section.id);
        section.selectors.forEach((selector) => {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.outerHTML = sourceElement.outerHTML;
          }
        });
      });
      if (updateURLHash) this.updateURLHash(filter.params);
      toggleLoader(false);
    }

    updateURLHash(searchParams) {
      const updatedSearchParams = setFilterParam(null, null, false, true);
      history.pushState(
        { searchParams },
        '',
        `${window.location.pathname}${updatedSearchParams && '?'.concat(updatedSearchParams)}`
      );
    }
  }
  if (!customElements.get('facets-filter')) customElements.define('facets-filter', FacetsFilter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search-results"]) return;
  try {
    
  const trapFocus = (container, elementToFocus = container, shouldTrap = true) => {
    const handlers = trapFocus._handlers || (trapFocus._handlers = {});
    const getFocusableElements = (container) => {
      return Array.from(
        container.querySelectorAll(
          "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
      );
    };
    const remove = (focusTarget = null) => {
      document.removeEventListener('focusin', handlers.focusin);
      document.removeEventListener('focusout', handlers.focusout);
      document.removeEventListener('keydown', handlers.keydown);
      if (focusTarget) focusTarget.focus();
    };
    if (!shouldTrap) {
      remove(elementToFocus);
      return;
    }
    const elements = getFocusableElements(container);
    const first = elements[0];
    const last = elements[elements.length - 1];
    remove();
    handlers.keydown = (event) => {
      if (event.code.toUpperCase() !== 'TAB') return;
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
      if ((event.target === container || event.target === first) && event.shiftKey) {
        event.preventDefault();
        last.focus();
      }
      if (!container.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    };
    handlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      ) return;
      document.addEventListener('keydown', handlers.keydown);
    };
    handlers.focusout = () => {
      document.removeEventListener('keydown', handlers.keydown);
    };
    document.addEventListener('focusin', handlers.focusin);
    document.addEventListener('focusout', handlers.focusout);
    elementToFocus.focus();
    if (
      elementToFocus.tagName === 'INPUT' &&
      ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
      elementToFocus.value
      ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
      }
  };
  const debounce = (fn, wait) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  const setFilterParam = (param, value, remove = false, getParams = false) => {
    const input = document.getElementById('filters-params');
    const url = new URL(input.value, window.location.origin);
    if (getParams) return new URLSearchParams(url.searchParams).toString();
    switch (remove) {
      case true:
        if (param.includes('price')) {
          [...url.searchParams.keys()].forEach(key =>
            key.includes('filter.v.price') && url.searchParams.delete(key)
          );
        } else {
          if(!value){
            url.searchParams.delete(param);
          } else{
            const valToDel = value;
            const values = url.searchParams.getAll(param);
            const updatedValues = values.filter(value => value !== valToDel);
            url.searchParams.delete(param);
            updatedValues.forEach(value => url.searchParams.append(param, value));
          }
        }
        break;
      case 'all':
        [...url.searchParams.keys()].forEach(key =>
          key.includes('filter') && url.searchParams.delete(key)
        );
        break;

      default:
        if (param.includes('price')) {
          url.searchParams.set(param, value);
        } else {
          url.searchParams.append(param, value);
        }
        break;
    }

    input.value = url.toString();
  };
  const toggleLoader = (state) => {
    const loader = document.querySelector('[data-theme-loader]');
    if(!loader) return;
    if(state){
      loader.style.display = 'flex';
      loader.animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 300,
        fill: 'forwards',
        easing: 'ease'
      }).onfinish = () => {
        loader.classList.add('theme-loader--active');
      };
      return;
    }
    loader.animate([{ opacity: 1 }, { opacity: 0 }], {
      duration: 300,
      fill: 'forwards',
      easing: 'ease'
    }).onfinish = () => {
      loader.classList.remove('theme-loader--active');
      loader.style.display = 'none';
    };
  };
  class FiltersDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.items = this.querySelectorAll('input');
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }
    connectedCallback() {
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query)){
          this.content.classList.add(...classes);
          return;
        }
        if (screen.width >= query) this.content.classList.add(...classes);
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
        this.initFilters();
        if(this.closeButton) this.closeButton.addEventListener('click', this.closeDropdown);
      };
      const closeDropdown = () => {
        closeDetailsTag();
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        self.button.focus();
        document.body.removeEventListener('click', onBodyClick);
        self.removeEventListener('keyup', onKeyUp);
        this.fields.forEach(field => {
          field.removeEventListener('input', this.debouncedOnSubmit.bind(this));
        });
        if(this.closeButton) this.closeButton.removeEventListener('click', this.closeDropdown);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          target === self.button && self.button.getAttribute('aria-expanded') === 'true'
        ) return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      const closeDetailsTag = () => {
        const tags = this.querySelectorAll('details');
        tags.forEach(tag => {
          tag.removeAttribute('open');
        });
      };
      applyColorScheme();
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }

    initFilters(){
      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 500);
      this.fields = this.querySelectorAll('input');
      this.fields.forEach(field => {
        field.addEventListener('input', this.debouncedOnSubmit.bind(this));
      });
    }

    onSubmitHandler(event){
      event.preventDefault();
      const target = event.target;
      switch(target.type){
        case 'checkbox':
          setFilterParam(target.name, target.value, !target.checked);
          break;
        case 'number':
          setFilterParam(target.name, target.value);
          break;
        default:
          break;
      }
      const facetsFilter = document.querySelector('facets-filter');
      facetsFilter.onSubmitHandler(target.id);
    }
  }
  if (!customElements.get('filters-dropdown')) { customElements.define('filters-dropdown', FiltersDropdown); }
  class SortDropdown extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('[data-dropdown-toggler]');
      this.content = this.querySelector('[data-dropdown-content]');
      this.items = this.content.querySelectorAll('[data-btn-sort]');
      this.closeButton = this.querySelector('[data-dropdown-close-btn]');
      if (!this.button || !this.content) return;
      this.button.addEventListener('click', (event) => {
        if (this.button.getAttribute('aria-expanded') === 'true') return this.closeDropdown();
        this.openDropdown();
      });
    }
    connectedCallback() {
      const self = this;
      const doAnimate = (element) => {
        const parseJSON = (key) => {
          try {
            return JSON.parse(self.content.dataset[key]);
          } catch (e) {
            return null;
          }
        };
        const animationFrames = parseJSON('frames');
        const timing = parseJSON('options');
        if (!animationFrames || !timing) return;
        element.animate(animationFrames, timing);
      };
      const setCurrentValue = (target) => {
        const elem = self.button.querySelector('[data-current-value]');
        elem.textContent = target.dataset.text;
        setFilterParam('sort_by', target.dataset.value);
        const facetsFilter = document.querySelector('facets-filter');
        facetsFilter.onSubmitHandler();
        self.closeDropdown();
      }
      const onSortSelect = (event) => {
        const target = event.target;
        self.items.forEach(item => item.classList.remove('main-featured-product-grid_facets-sort-action-btn--active'));
        target.classList.add('main-featured-product-grid_facets-sort-action-btn--active');
        setCurrentValue(target);
      }
      const applyColorScheme = () => {
        const { colorScheme, schemeQuery } = this.dataset;
        if (!colorScheme) return;
        const classes = colorScheme.trim().split(/\s+/);
        const query = parseFloat(schemeQuery);
        if (!schemeQuery || isNaN(query)){
          this.content.classList.add(...classes);
          return;
        }
        if (screen.width >= query) this.content.classList.add(...classes);
      };
      const openDropdown = () => {
        self.button.setAttribute('aria-expanded', true);
        self.content.classList.add('dropdown--open');
        doAnimate(self.content);
        self.content.focus();
        trapFocus(self.content);
        document.body.addEventListener('click', onBodyClick);
        self.addEventListener('keyup', onKeyUp);
        self.items.forEach(item => {item.addEventListener('click', self.sortSelect);});
        if(this.closeButton) this.closeButton.addEventListener('click', this.closeDropdown);
      };
      const closeDropdown = () => {
        const outerSelf = self.closest('menu-dropdown[data-level="1"]');
        self.button.setAttribute('aria-expanded', false);
        self.content.classList.remove('dropdown--open');
        if(self.dataset.level === '2') trapFocus(outerSelf.content);
        self.button.focus();
        document.body.removeEventListener('click', onBodyClick);
        self.removeEventListener('keyup', onKeyUp);
        this.items.forEach(item => {item.removeEventListener('click', self.sortSelect);});
        if(this.closeButton) this.closeButton.removeEventListener('click', this.closeDropdown);
      };
      const onBodyClick = (event) => {
        const target = event.target;
        if (
          self.contains(target) ||
          target === self ||
          target === self.button && self.button.getAttribute('aria-expanded') === 'true'
        ) return;
        closeDropdown();
      };
      const onKeyUp = (event) => {
        if (event.key !== 'Escape') return;
        event.stopPropagation();
        closeDropdown();
      };
      applyColorScheme();
      this.sortSelect = onSortSelect.bind(this);
      this.openDropdown = openDropdown;
      this.closeDropdown = closeDropdown;
    }
  }
  if (!customElements.get('sort-dropdown')) { customElements.define('sort-dropdown', SortDropdown); }
  
  class FacetRemoveButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      if (!this.button) return;

      this.button.addEventListener('click', (event) => {
        event.preventDefault();

        const { name, value, valueArr } = this.dataset;
        const values = valueArr || value || null;

        setFilterParam(name === 'all' ? null : name, values, name === 'all' ? 'all' : true);

        const facetsFilter = document.querySelector('facets-filter');
        facetsFilter?.onSubmitHandler?.();
      });
    }
  }

  if (!customElements.get('facet-remove-button'))
    customElements.define('facet-remove-button', FacetRemoveButton);


  class FacetsFilter extends HTMLElement {
    constructor() {
      super();

      this.cachedResults = [];
      window.addEventListener('popstate', this.onHistoryChange.bind(this));
    }

    connectedCallback(){
      this.initParams = setFilterParam(null, null, false, true);
    }

    onHistoryChange(event){
      if(event.state && this.cachedResults.length === 0){
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const sectionsInput = document.querySelector('#filters-sections');
        const baserUrl = document.querySelector('#base-url');
        const url = baserUrl.value + '?' + searchParams + sectionsInput.value;
        this.renderFetch(url, false, searchParams);
        return;
      }
      
      if(this.cachedResults && this.cachedResults.length > 0){
        const searchParams = event.state ? event.state.searchParams : this.initParams;
        const term = {params: searchParams};
        if (this.cachedResults.some(key => key.params === term.params)) return this.renderFromCache(this.cachedResults, term, false);
        const sectionsInput = document.querySelector('#filters-sections');
        const baserUrl = document.querySelector('#base-url');
        const url = baserUrl.value + '?' + searchParams + sectionsInput.value;
        this.renderFetch(url, false, searchParams);
      }
    }

    onSubmitHandler(target){
      toggleLoader(true);
      const input = document.querySelector('#filters-params');
      let inputValue = input.value;
      if(!inputValue.includes('?')) inputValue = input.value + '?';
      const sectionsInput = document.querySelector('#filters-sections');
      const url = inputValue + sectionsInput.value;
      const searchParams = setFilterParam(null, null, false, true);
      const term = {params: searchParams};
      if(this.cachedResults.length > 0 && this.cachedResults.some(key => key.params === term.params)){
        this.renderFromCache(this.cachedResults, term, true, target);
        return;
      }
      this.renderFetch(url, true, searchParams, target);
    }

    renderFetch(url, updateURLHash = false, searchParams, target = null){
      fetch(url)
        .then(response => response.json())
        .then((data) => {
          const secArr = JSON.parse(this.dataset.sections);
          secArr.forEach(section => {
            const html = new DOMParser() .parseFromString(data[section.id], 'text/html').getElementById(section.id);
            section.selectors.forEach(selector => {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.outerHTML = sourceElement.outerHTML;
              }
            });
          });
          const cacheObj = {params: searchParams, content: data};
          this.cachedResults.push(cacheObj);
        })
        .catch((e) => {
          throw e;
        })
        .finally(() => {
          if(updateURLHash) this.updateURLHash(searchParams);
          if(target){
            const org = document.getElementById(target);
            if(org) org.focus();
          }
          toggleLoader(false);
        }
      );
    }

    renderFromCache(cache, filter, updateURLHash = false, target = null){
      const cacheDataArr = cache;
      const cachedResults = cacheDataArr.find(results => results.params === filter.params);
      const secArr = JSON.parse(this.dataset.sections);
      secArr.forEach(section => {
        const html = new DOMParser() .parseFromString(cachedResults.content[section.id], 'text/html').getElementById(section.id);
        section.selectors.forEach(selector => {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.outerHTML = sourceElement.outerHTML;
          }
        });
      });
      if(updateURLHash) this.updateURLHash(filter.params);
      toggleLoader(false);
    }

    updateURLHash(searchParams){
      const updatedSearchParams = setFilterParam(null, null, false, true);
      history.pushState({ searchParams }, '', `${window.location.pathname}${updatedSearchParams && '?'.concat(updatedSearchParams)}`);
    }
  }
  if(!customElements.get('facets-filter')) customElements.define('facets-filter', FacetsFilter);

  } catch(e) { console.error(e); }
})();
})();
